export default "__VITE_ASSET__DCQ$LMFk__"